module.exports = __webpack_public_path__ + "media/images/flags/4x3/arg-6a7b7b250a7f0f3960e168394488b601.svg";